/* Vitne storefront behaviour. No dependencies. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function money(c, short) { var v = (Number(c) / 100).toFixed(2).split('.'); v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); var s = v.join(','); if (short) s = s.replace(/,00$/, ''); return s + ' €'; }
  var WARM = ['Sommer', 'Leicht', 'Ganzjahr', 'Warm', 'Winter'];

  /* toast + count */
  var tt;
  function toast(t) { var el = $('[data-vt-toast]'); if (!el) return; $('[data-vt-toast-text]', el).textContent = t; el.classList.add('is-show'); clearTimeout(tt); tt = setTimeout(function () { el.classList.remove('is-show'); }, 4000); }
  function refreshCount() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { $$('[data-vt-count]').forEach(function (el) { el.textContent = c.item_count; }); return c; }).catch(function () {}); }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('vt-addform') || !window.fetch) return;
    e.preventDefault();
    var btn = e.submitter || $('[type=submit]', f);
    if (btn) btn.classList.add('is-loading');
    var data = new FormData(f);
    if (!(parseInt(data.get('quantity') || '1', 10) > 0)) data.set('quantity', '1');
    fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { if (btn) btn.classList.remove('is-loading'); if (!res.ok) { toast(res.j.description || 'Das hat nicht geklappt.'); return; } toast('Im Warenkorb: ' + (res.j.product_title || 'Artikel')); refreshCount(); })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); f.submit(); });
  });

  /* header */
  var drawer = $('[data-vt-drawer]');
  function setDrawer(o) { if (!drawer) return; drawer.classList.toggle('is-open', o); document.documentElement.style.overflow = o ? 'hidden' : ''; }
  $$('[data-vt-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); b.setAttribute('aria-expanded', 'true'); }); });
  $$('[data-vt-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  $$('.vt-drawer a').forEach(function (a) { a.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setDrawer(false); closeTips(); } });
  $$('[data-vt-search-toggle]').forEach(function (b) { b.addEventListener('click', function () { var s = $('[data-vt-search]'); s.classList.toggle('is-open'); if (s.classList.contains('is-open')) $('input[type=search]', s).focus(); }); });
  $$('[data-vt-cookie]').forEach(function (b) { b.addEventListener('click', function () { if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences(); else window.location.href = root + 'pages/datenschutz'; }); });

  /* tabs */
  $$('[data-vt-tabs]').forEach(function (w) {
    var tabs = $$('[role=tab]', w);
    tabs.forEach(function (t) { t.addEventListener('click', function () { tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-pressed', on ? 'true' : 'false'); x.setAttribute('aria-selected', on ? 'true' : 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; }); }); });
  });

  /* hero hotspots */
  function closeTips(except) { $$('[data-vt-hot]').forEach(function (b) { if (b === except) return; b.setAttribute('aria-expanded', 'false'); var t = document.getElementById(b.getAttribute('aria-controls')); if (t) t.hidden = true; }); }
  $$('[data-vt-hot]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.stopPropagation(); var open = b.getAttribute('aria-expanded') !== 'true'; closeTips(b); b.setAttribute('aria-expanded', open ? 'true' : 'false'); document.getElementById(b.getAttribute('aria-controls')).hidden = !open; });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.vt-hot')) closeTips(); });
  var firstHot = $$('[data-vt-hot]')[1] || $$('[data-vt-hot]')[0];
  if (firstHot && window.innerWidth > 767) firstHot.click();

  /* hero quick size */
  $$('[data-vt-quick]').forEach(function (q) {
    var id = $('[data-vt-quick-id]', q), price = $('[data-vt-quick-price]', q);
    $$('.vt-sizes .vt-chip', q).forEach(function (c) { c.addEventListener('click', function () { $$('.vt-sizes .vt-chip', q).forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); }); id.value = c.dataset.id; price.textContent = c.dataset.price; }); });
  });

  /* Wärme-Finder */
  $$('[data-vt-finder]').forEach(function (f) {
    var state = { sleep: 0, room: 'mid', two: 0 };
    var base = { cold: +f.dataset.baseCold, mid: +f.dataset.baseMid, warm: +f.dataset.baseWarm };
    var recs = $$('[data-vt-rec]', f);
    function why(s, lvl) {
      var a = s.sleep > 0 ? 'Ihr schlaft eher kalt' : s.sleep < 0 ? 'Ihr schlaft eher warm' : 'Ihr schlaft normal';
      var b = s.room === 'cold' ? 'das Zimmer ist kühl' : s.room === 'warm' ? 'das Zimmer ist warm' : 'das Zimmer ist mäßig warm';
      var t = a + ', ' + b + ': Wärme ' + lvl + ' (' + WARM[lvl - 1] + ') passt.';
      if (s.two) t += ' Zu zweit unter einer Decke wird es wärmer, darum eine Stufe weniger. Nehmt am besten 200 × 200 cm.';
      return t + ' Und wenn nicht: Innerhalb von ' + f.dataset.nights + ' Nächten tauschen wir um.';
    }
    function calc() {
      var lvl = base[state.room] + state.sleep - (state.two ? 1 : 0);
      lvl = Math.max(1, Math.min(5, lvl));
      var avail = recs.map(function (r) { return +r.dataset.vtRec; });
      var best = avail.reduce(function (p, c) { return Math.abs(c - lvl) < Math.abs(p - lvl) ? c : p; }, avail[0]);
      recs.forEach(function (r) { var on = +r.dataset.vtRec === best; r.hidden = !on; if (on) { $('[data-vt-rec-why]', r).textContent = why(state, lvl); var a = $('[data-vt-rec-link]', r); if (a && state.two) { a.href = a.href.split('?')[0]; } } });
    }
    $$('[data-q]', f).forEach(function (fs) {
      var key = fs.dataset.q;
      $$('.vt-chip', fs).forEach(function (b) { b.addEventListener('click', function () {
        $$('.vt-chip', fs).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        state[key] = key === 'room' ? b.dataset.v : +b.dataset.v; calc();
      }); });
    });
    calc();
  });

  /* collection filters + sort */
  var col = $('[data-vt-col]');
  if (col) {
    var grid = $('[data-vt-grid]', col), cards = $$('.vt-card', grid), feat = $('[data-vt-feature]', grid), empty = $('[data-vt-empty]', col), count = $('[data-vt-col-count]', col), sort = $('[data-vt-sort]', col);
    var st = { w: '', size: '', cover: '', price: '' }, orig = cards.slice();
    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (st.w && c.dataset.warmth !== st.w) ok = false;
        if (st.size && c.dataset.sizes.indexOf('|' + st.size + '|') < 0) ok = false;
        if (st.cover && c.dataset.covers.indexOf('|' + st.cover + '|') < 0) ok = false;
        if (st.price) { var r = st.price.split('-'), p = +c.dataset.price; if (p < +r[0] || p > +r[1]) ok = false; }
        c.hidden = !ok; if (ok) n++;
      });
      if (feat) feat.hidden = !!(st.w || st.size || st.cover || st.price);
      empty.hidden = n > 0; count.textContent = n + ' Artikel';
    }
    function doSort() {
      var v = sort.value, arr = orig.slice();
      if (v === 'warm-asc') arr.sort(function (a, b) { return a.dataset.warmth - b.dataset.warmth || a.dataset.price - b.dataset.price; });
      if (v === 'warm-desc') arr.sort(function (a, b) { return b.dataset.warmth - a.dataset.warmth; });
      if (v === 'price-asc') arr.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      if (v === 'price-desc') arr.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      if (v === 'title') arr.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title, 'de'); });
      arr.forEach(function (c) { grid.insertBefore(c, empty); });
      if (feat && arr[3]) grid.insertBefore(feat, arr[3]);
    }
    $$('[data-vt-f-warm] .vt-chip', col).forEach(function (b) { b.addEventListener('click', function () { $$('[data-vt-f-warm] .vt-chip', col).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); st.w = b.dataset.w; apply(); }); });
    $$('[data-vt-f]', col).forEach(function (s) { s.addEventListener('change', function () { st[s.dataset.vtF] = s.value; s.classList.toggle('is-set', !!s.value); apply(); }); });
    var rs = $('[data-vt-reset]', col);
    if (rs) rs.addEventListener('click', function () { st = { w: '', size: '', cover: '', price: '' }; $$('[data-vt-f]', col).forEach(function (s) { s.value = ''; s.classList.remove('is-set'); }); $$('[data-vt-f-warm] .vt-chip', col).forEach(function (x, i) { x.setAttribute('aria-pressed', i === 0 ? 'true' : 'false'); }); apply(); });
    sort.addEventListener('change', doSort);
    doSort(); apply();
  }

  /* product page */
  var pdp = $('[data-vt-product]');
  if (pdp) {
    var vEl = $('[data-vt-variants]'), variants = vEl ? JSON.parse(vEl.textContent) : [], idIn = $('[data-vt-variant]', pdp), qty = $('[data-vt-qty]', pdp);
    var sets = $$('[data-vt-option]', pdp);
    function selected() { return sets.map(function (fs) { var r = $('input:checked', fs); return r ? r.value : null; }); }
    function sizeIndex() { var i = 0; sets.forEach(function (fs, j) { if (fs.dataset.name === 'Größe' || fs.dataset.name === 'Inhalt') i = j; }); return i; }
    function update() {
      var sel = selected(), m = variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!m) return;
      idIn.value = m.id;
      $$('[data-vt-price], [data-vt-sticky-price]').forEach(function (el) { el.textContent = money(m.price, true); });
      var sv = $('[data-vt-sticky-var]'); if (sv) sv.textContent = m.title.replace(/ \/ /g, ' · ');
      var si = sizeIndex();
      sets.forEach(function (fs, oi) {
        if (fs.dataset.name !== 'Bezug') return;
        var first = $$('input', fs)[0].value;
        var basev = variants.filter(function (v) { return v.options[si] === sel[si] && v.options[oi] === first; })[0];
        $$('label', fs).forEach(function (l) { var inp = $('input', l), d = $('[data-vt-delta]', l); if (!d || !basev) return; var vv = variants.filter(function (v) { return v.options[si] === sel[si] && v.options[oi] === inp.value; })[0]; if (vv) d.textContent = '+ ' + money(vv.price - basev.price, true); });
      });
      var url = new URL(window.location.href); url.searchParams.set('variant', m.id); window.history.replaceState({}, '', url.toString());
    }
    $$('[data-vt-option] input', pdp).forEach(function (i) { i.addEventListener('change', update); });
    $$('[data-vt-qty-step]', pdp).forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.vtQtyStep)); }); });
  }

  /* cart */
  var cart = $('[data-vt-cart]');
  if (cart) {
    var t2;
    function soon() { clearTimeout(t2); t2 = setTimeout(function () { cart.submit(); }, 450); }
    $$('[data-vt-step]', cart).forEach(function (b) { b.addEventListener('click', function () { var i = $('[data-vt-line-qty]', b.parentNode); i.value = Math.max(0, (parseInt(i.value, 10) || 0) + Number(b.dataset.vtStep)); soon(); }); });
    $$('[data-vt-line-qty]', cart).forEach(function (i) { i.addEventListener('change', soon); });
    function saveAttrs(extra) {
      var msg = $('[data-vt-gift-text]', cart), note = $('#vt-note');
      var body = { attributes: Object.assign({ Geschenknachricht: msg ? msg.value : '' }, extra || {}), note: note ? note.value : '' };
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    }
    var gift = $('[data-vt-gift]', cart);
    if (gift) {
      var tog = $('[data-vt-gift-toggle]', gift), box = $('[data-vt-gift-msg]', gift), txt = $('[data-vt-gift-text]', gift), left = $('[data-vt-gift-left]', gift);
      function counter() { left.textContent = Math.max(0, (+txt.getAttribute('maxlength')) - txt.value.length); }
      txt.addEventListener('input', counter); txt.addEventListener('change', function () { saveAttrs(); }); counter();
      tog.addEventListener('change', function () {
        tog.disabled = true;
        var p = tog.checked
          ? fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +gift.dataset.variant, quantity: 1 }] }) }).then(function () { return saveAttrs({ Lieferschein: 'Preise ausblenden', Geschenk: 'Ja' }); })
          : fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(gift.dataset.variant), quantity: 0 }) }).then(function () { return saveAttrs({ Lieferschein: '', Geschenk: '', Geschenknachricht: '' }); });
        p.then(function () { window.location.reload(); }).catch(function () { tog.disabled = false; });
      });
    }
    var note = $('#vt-note'); if (note) note.addEventListener('change', function () { saveAttrs(); });
    var co = $('[data-vt-coupon-open]'), cb = $('[data-vt-coupon]');
    if (co) co.addEventListener('click', function () { cb.hidden = !cb.hidden; if (!cb.hidden) $('input', cb).focus(); });
    function applyC() { var c = ($('[data-vt-coupon-input]').value || '').trim(); if (c) window.location.href = root + 'discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent(root + 'cart'); }
    var ca = $('[data-vt-coupon-apply]'); if (ca) { ca.addEventListener('click', applyC); $('[data-vt-coupon-input]').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyC(); } }); }
    var eta = $('[data-vt-eta]');
    if (eta) {
      var d1 = new Date(), d2, n = 0; function add(d, k) { var x = new Date(d); var c = 0; while (c < k) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) c++; } return x; }
      var a = add(d1, 2), b = add(d1, 4); var f = function (d) { return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.'; };
      eta.textContent = 'Voraussichtlich bei euch zwischen ' + f(a) + ' und ' + f(b) + d1.getFullYear().toString().slice(0) + ', mit DHL';
      eta.textContent = 'Voraussichtlich bei euch zwischen ' + f(a) + ' und ' + f(b) + ', mit DHL';
    }
  }
})();
